// src/services/remoteLoggingService.js

const LOG_SERVER_URL = 'http://localhost:3001/log';

/**
 * Sends a log message to the local log server.
 * @param {'error' | 'warn' | 'info'} level - The log level.
 * @param {string} message - The error message.
 * @param {string} [stack] - The error stack trace.
 */
function logToServer(level, message, stack) {
  // We use navigator.sendBeacon if available, as it's a non-blocking way
  // to send data, especially useful for errors that occur when the user is navigating away.
  // However, sendBeacon only supports POST with certain data types, and not all browsers
  // support it with Blob for JSON content. A standard fetch is a reliable fallback.

  const timestamp = new Date().toISOString();
  const logData = {
    level,
    message,
    stack,
    timestamp,
    userAgent: navigator.userAgent,
    url: window.location.href,
  };

  const headers = {
    'Content-Type': 'application/json',
  };

  // fetch(LOG_SERVER_URL, {
  //   method: 'POST',
  //   headers,
  //   body: JSON.stringify(logData),
  //   keepalive: true, // This helps ensure the request is sent even if the page is unloading
  // }).catch(console.error); // Log fetch errors to the console itself
}

export const remoteLogger = {
  error: (message, stack) => logToServer('error', message, stack),
  warn: (message) => logToServer('warn', message, ''),
  info: (message) => logToServer('info', message, ''),
};
